import { ISessionState } from 'src/reducer/order/orderReducer';
import { instance } from './config';
import { IApproveReq, IInterestReq, IPrincipalWeborder } from './types';
import { types as rs } from 'earn-ts';
import { AxiosResponse } from 'axios';

export const getSpending = () => {
  return instance.get('/api/admin/spend/pending');
};

export const getImage = (id: string) => {
  return instance.get(`/api/admin/spend/image/${id}`);
};

export const postApprove = (data: IApproveReq) => {
  return instance.post('api/admin/spend/approve', data);
};

export const getMember = (code: string) => {
  return instance.get(`/api/user/memb/${code}`);
};

export const getInfo = () => {
  return instance.get(`/api/info`);
};

export const getListPrize = () => {
  return instance.get('api/admin/prizes');
};

export const postPrize = (id: string) => {
  return instance.post(`api/admin/prizes/${id}/shipped`);
};

export const getListShop = () => {
  return instance.get(`api/admin/shop`);
};

export const getReportByMonth = (id: number, month: number) => {
  return instance.get(`api/admin/shop/${id}/month-end/${month}`);
};

export const getReportByTime = (id: number, timeframe: string) => {
  return instance.get(`api/admin/shop/${id}/${timeframe}`);
};

export const getStatisticUsers = (since: number) => {
  return instance.get(`api/admin/stats/users/new?since=${since}`);
};

export const deleteAdminUser = (name: string) => {
  return instance.post(`api/admin/testing/del/${name}`);
};

export const initLogin = () => {
  return instance.post(`/api/weborder/init`);
};

export const getAuthInfo = () => {
  return instance.get(`/api/weborder/auth/info`);
};

export const prepareLogin = (data: IPrincipalWeborder) => {
  return instance.post(`/api/weborder/auth/prepare`, data);
};

const authHeaders = (sess: ISessionState) =>
  sess.kind == 'Table'
    ? {
        Authorization: `Table ${sess.code}`,
      }
    : {};

// don't like global state. Pure functions FTW
// also, usue the thunk instead
export const getCurrentOrder = async (sess: ISessionState) => {
  return (await instance.get(`/api/weborder/order`, {
    headers: authHeaders(sess),
  })) as AxiosResponse<rs.CurrentOrderResponse, any>;
};

export const getFullCurrentOrder = async (sess: ISessionState) => {
  let r = (await getCurrentOrder(sess)).data;

  if (r == 'None' || 'IdOnly' in r) {
    throw new Error('no order, try again');
  }
  return r.Exists;
};

export const postItemsToOrder = async (
  sess: ISessionState,
  items: rs.OrderMenuSet[],
) => {
  return await instance.post(`/api/weborder/order/items`, items, {
    headers: authHeaders(sess),
  });
};

export const getMenu = async (sess: ISessionState) => {
  return await instance.get(`/api/weborder/menu`, {
    headers: authHeaders(sess),
  });
};
